import SlideFrame from './SlideFrame';

interface Props {
  title: string; sub: string;
  problem_t: string; problem: string[];
  solution_t: string; solution: string[];
}

export default function ProblemSolution({ title, sub, problem_t, problem, solution_t, solution }: Props) {
  return (
    <SlideFrame title={title} sub={sub}>
      <div className="ps-grid">
        <div className="ps-card ps-card--problem">
          <div className="ps-card-t">{problem_t}</div>
          <ul className="ps-list">
            {problem.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </div>
        <div className="ps-card ps-card--solution">
          <div className="ps-card-t">{solution_t}</div>
          <ul className="ps-list">
            {solution.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </div>
      </div>
    </SlideFrame>
  );
}
